<template src="./reportsPage.html"></template>

<script>
import rightButtonMenu from '../../../components/RightButtonMenu/rightButtonMenu.vue';
import titlePage from './tabComponents/titlePage/titlePage.vue';
import faultsPage from './tabComponents/faultsPage/faultsPage.vue';
import plotsPage from './tabComponents/plotsPage/plotsPage.vue';
import defectsPage from './tabComponents/defectsPage/defectsPage.vue';
import additionalPage from './tabComponents/additionalPage/additionalPage.vue'
import manholePage from './tabComponents/manholePage/manholePage.vue';
import videoPage from './tabComponents/videoPage/videoPage.vue';
import observationsEndpoints from '../../observations/observations.endpoints';
import reportEndpoints from '../reports.endpoints';
import reportMixin from '../../../js/reportMixin';

export default {
    name: 'reports-page',
    mixins: [reportMixin],
    components: {
        'right-button-menu': rightButtonMenu,
        'title-page': titlePage,
        'faults-page': faultsPage,
        'plots-page': plotsPage,
        'defects-page': defectsPage,
        'additional-page': additionalPage,
        'manhole-page': manholePage,
        'video-page': videoPage
    },
    data() {
        return {
            selectedTab: 'TitlePage',
            observationsDetails: [],
            faultsObservations: [],
            headerOptionsAndValues: [],
            reportHeaders: {},
            headerFields: { text: 'LabelText', value: 'LabelText' },
            sessionFields: [],
            unsavedHeaderChanges: false,
            unsavedSettingsChanges: false,
            faultPictureCodes: [],
            pipeFlow: '',
            originalReportSettings: {},
            printAll: true,
            printTitlePage: true,
            printFaultsPage: true,
            printPlotPage: true,
            printDefectPage: true,
            //printVideoPage: true,
            printManholePage: true, 
            //printAdditionalPage: true,
            isPrinting: false,
            plotPageIsReady: false,
            editReportSettingsKey: 0
        };
    },
    computed: {
        userIsEditUser() {
            return (
                this.$store.state.AuthorizationModule.SignedInUser.Role != 'Guest' &&
                this.$store.state.AuthorizationModule.SignedInUser.Role != 'View-Only'
            );
        },
        session() {
            return this.$store.state.SessionsModule.Session;
        },
        sessionTemplate() {
            if (this.$store.state.SessionsModule.Session) {
                return this.$store.state.SessionsModule.Session.TemplateName;
            }

            return '';
        },
        showDefectTab() {
            if (this.sessionTemplate && this.sessionTemplate.toLowerCase().includes('posm')) {
                return false;
            }

            return true;
        },
        showManholeTab() {
            if (this.sessionTemplate && this.sessionTemplate.toUpperCase().includes('MACP')) {
                return true;
            }

            return false;
        },
        rightMenuButtons() {
           let rightMenuButtons =  [
                {
                    text: 'View Observations',
                    icon: 'fa-search',
                    color: 'brand-color-primary',
                    onClick: this.navigateToObservationForSession,
                    isVisible: true,
                },
                {
                    text: this.userIsEditUser ? 'Edit Headers' : 'View Headers',
                    icon: 'fa-list',
                    color: 'brand-color-alternate-1',
                    onClick: this.navigateToHeadersForSession,
                    isVisible: true,
                },
                {
                    text: this.userIsEditUser ? 'Edit Report Headers' : 'View Report Headers',
                    icon: 'fa-file-text-o',
                    color: 'brand-color-alternate-2',
                    onClick: this.toggleReportHeadersSidebar,
                    isVisible: true,
                },
                {
                    text: 'Print Report(s)',
                    icon: 'fas fa-print',
                    color: 'brand-color-alternate-4',
                    onClick: this.togglePrintReportSideBar,
                    isVisible: true,
                }
            ];

            if (this.selectedTab === 'Faults' || this.selectedTab === 'Plot' || this.selectedTab === 'Defect') {
                rightMenuButtons.push(
                {
                    text: 'Report Settings',
                    icon: 'fas fa-cogs',
                    color: 'brand-color-alternate-3',
                    onClick: this.toggleReportSettingsSideBar,
                    isVisible: true,
                })
            }
            else {
                rightMenuButtons = rightMenuButtons.filter(x => x.text !== 'Report Settings')
            }

            return rightMenuButtons;
        },
        reportSettings() {
            return this.$store.state.ReportsModule.ReportSettings;
        }
    },
    methods: {
        changeTab(selectedTab) {
            if (this.$refs.editReportSettings.ej2Instances.isOpen) {
                this.revertReportSettingsAndToggle();
            }
            this.selectedTab = selectedTab;
        },
        btnSaveHeadersOnClick() {
            return reportEndpoints.updateHeaders(this.reportHeaders)
                .then(() => {
                    this.unsavedHeaderChanges = false;
                    this.toggleReportHeadersSidebar();
                })
        },
        btnCloseHeadersOnClick() {
            if (this.unsavedHeaderChanges) {
                let message = 'You have unsaved changes. Are you sure you want to close?';
                let title = 'Confirm';
                DMUtils.confirmShow(message, title, this.revertReportHeadersAndToggle, null, 'Yes', 'No');
            } else {
                this.toggleReportHeadersSidebar();
            }
        },
        btnSaveSettingsOnClick() {
            this.$store.dispatch('ReportsModule/updateReportSettings', this.reportSettings)
                .then(() => {
                    this.originalReportSettings = this.$store.state.ReportsModule.ReportSettings;
                    this.unsavedSettingsChanges = false;
                    this.toggleReportSettingsSideBar();
                });
        },
        btnCloseSettingsOnClick() {
            if (this.unsavedSettingsChanges) {
                let message = 'You have unsaved changes. Are you sure you want to close?';
                let title = 'Confirm';
                DMUtils.confirmShow(message, title, this.revertReportSettingsAndToggle, null, 'Yes', 'No');
            } else {
                this.toggleReportSettingsSideBar();
            }
        },
        btnPrintReportOnClick() {
            this.isPrinting = true;
            DMUtils.spinnerShow();  

            this.$nextTick(() => {   
                this.checkIfPageReady()
                    .then(() => {
                        let contentHtml = document.getElementById('print-wrapper').innerHTML;
                        let iframe = document.createElement('iframe');
                        iframe.style.display = 'block';
                        
                        document.body.appendChild(iframe);

                        const cssLinks = Array.from(document.querySelectorAll('link[rel="stylesheet"]'))
                            .map(link => `<link rel="stylesheet" href="${link.href}">`)
                            .join('\n');

                        let combinedStyles = '';
                        
                        document.querySelectorAll('style').forEach(style => {
                            combinedStyles += style.innerHTML;
                        });

                        combinedStyles += `
                            .page {
                                -webkit-print-color-adjust: exact; 
                                margin: 0px;
                                page-break-after: always;
                                break-after: page;
                                display: block;
                                min-height: 100vh;
                                color: #000 !important;
                            }

                            .app-report-table {
                                width: 100%;
                            }

                            .app-report-table thead th {
                                background-color: white;
                            }

                            .no-print {
                                display: none;
                            }

                            .app-print-only {
                                visibility: visible;
                                height: 100%;
                                width: 100%;
                            }

                            .plots-print {
                                height: auto !important;
                            }

                            .manhole-id-print {
                                margin-top: 30px;
                            }

                            .pipe-image-report {
                                color: white;
                            }

                            @media print {
                                body {
                                    -webkit-print-color-adjust: exact;
                                    print-color-adjust: exact;
                                }
                            }
                        `;

                        let doc = iframe.contentWindow.document;

                        doc.open();

                        doc.write(`
                            <html>
                                <head>
                                    ${cssLinks}
                                    <style>${combinedStyles}</style>
                                </head>
                                <body>
                                    ${contentHtml}
                                </body>
                            </html>
                        `);

                        doc.close();

                        iframe.onload = () => {
                            // Let styles/layout settle before printing
                            requestAnimationFrame(() => {
                                requestAnimationFrame(() => {
                                    iframe.contentWindow.focus();
                                    iframe.contentWindow.print();
                                    DMUtils.spinnerHide();  

                                    // Clean up after print
                                    setTimeout(() => {
                                        document.body.removeChild(iframe);
                                        this.isPrinting = false;
                                    }, 1000);
                                });
                            });
                        }           
                })
            });  
        },
        
        btnClosePrintReportOnClick() {
            this.togglePrintReportSideBar();
        },
        handleAfterPrint() {
            this.isPrinting = false;
        },
        toggleReportHeadersSidebar() {
            this.$refs.editReportHeaders.toggle();
        },
        toggleReportSettingsSideBar() {
            if (this.$refs.editReportSettings.ej2Instances.isOpen === false) {
                this.editReportSettingsKey++;
            }
            this.$nextTick(() => {
                this.$refs.editReportSettings?.toggle();
            });
        },
        togglePrintReportSideBar() {
            this.$refs.printReport.toggle();
        },
        navigateToHeadersForSession() {
            this.$store.commit('SessionsModule/setNavigatedToHeadersFrom', 'reports');
            this.$router.push({ name: 'headers', query: { id: this.$route.query.id } });
        },
        navigateToObservationForSession() {
            this.$store.commit('SessionsModule/setNavigatedToHeadersFrom', 'reports');
            this.$router.push({ name: 'observations', query: { id: this.$route.query.id } });
        },
        setUnsavedHeaderChanges(args, value) {
            this.unsavedHeaderChanges = value;
        },
        setUnsavedSettingsChanges(value) {
            this.unsavedSettingsChanges = value;
        },
        //TODO why is this here and on the plots page?
        checkIfPageReady() {
            return new Promise((resolve, reject) => {
                const start = Date.now();

                const check = () => {
                    if (this.$refs.plotComponent && this.$refs.plotComponent.ready) {
                        resolve();
                    } else if (Date.now() - start > 10000) {
                        resolve();
                    } else {
                        setTimeout(check, 50);
                    }
                };

                check();
            })
        },
        getHeaders() {
            reportEndpoints
                .getReportHeadersNameAndValue(this.session.SessionID)
                .then((response) => {
                    this.headerOptionsAndValues = response;
                    return reportEndpoints.getHeaders(this.sessionTemplate);
                })
                .then((response) => {
                    this.reportHeaders = response;
                    
                });
        },
        getObservationDetails() {
            return this.$store
                .dispatch('ObservationModule/getObservations', this.$route.query.id)
                .then(() => {
                    let observations = this.$store.state.ObservationModule.Observations;
                    this.observationsDetails.length = 0;
                    const promises = observations.map((obs, index) => {
                        return observationsEndpoints.getObservationByID(obs.ObservationID).then((response) => {
                            response.FaultCode = obs.FaultCode;
                            response.MaintWeight = obs.MaintWeight;
                            response.StructWeight = obs.StructWeight;
                            this.observationsDetails.push(response);
                        });
                    });
                    return Promise.all(promises);
                })
                .then(() => {
                    this.setObservationsForFaults();
                    this.getHeaders();
                    this.flattenSessionPages();
                    this.getFaultPictureCodes();
                });
        },
        setObservationsForFaults() {
            this.faultsObservations.length = 0;
            this.observationsDetails.forEach((obs) => {
                if (obs.Images.length === 0) {
                    this.faultsObservations.push(obs);
                    return;
                }

                //For each observation, create a new observation for each image
                for (let i = 0; i < obs.Images.length; i++) {
                    let additionalImageObservation = DMUtils.copy(obs);

                    if (i > 0) {
                        additionalImageObservation.PictureNumber = i + 1;
                    }

                    additionalImageObservation.Images = obs.Images.slice(i, i + 1);
                    this.faultsObservations.push(additionalImageObservation);
                }
            });
        },
        revertReportSettingsAndToggle() {
            this.$store.dispatch('ReportsModule/getReportSettings')
                .then(() => {
                    this.unsavedSettingsChanges = false;
                    this.getObservationDetails();
                    this.toggleReportSettingsSideBar();   
                })  
        },
        revertReportHeadersAndToggle() {
            this.getHeaders();
            this.toggleReportHeadersSidebar();
        },
        flattenSessionPages() {
            let pages = this.$store.state.SessionsModule.Session.SessionPages;
            let flattened = [];

            pages.forEach((page) => {
                page.Fields.forEach((field) => {
                    flattened.push(field);
                });
            });

            this.sessionFields = flattened;
            this.sessionFields;
            this.sessionFields.forEach((field) => {
                if (field.LabelText.toLowerCase() === 'direction of survey') {
                    this.pipeFlow = field.Value;
                }
            })
        },
        getFaultPictureCodes() {
            let uniqueCodes = [];
            this.observationsDetails.forEach((detail) => {
                if (!uniqueCodes.find((code) => code.name === detail.FaultName)) {
                    uniqueCodes.push({name: detail.FaultName, isChecked: true});
                }
            });

            uniqueCodes = uniqueCodes.sort((a, b) => {return a.name.localeCompare(b.name)});
            
            this.$store.commit('ReportsModule/setFaultPictureCodes', uniqueCodes);
            this.faultPictureCodes = uniqueCodes;
        },
        toggleFaultImageCheckbox(event, faultCode) {
            let faultCodes = this.$store.state.ReportsModule.FaultPictureCodes;
            let toggledCode = faultCodes.find((code) => code.name === faultCode);

            if (toggledCode) {
                toggledCode.isChecked = !toggledCode.isChecked;

                this.setUnsavedSettingsChanges(true);
            }

            this.$store.commit('ReportsModule/setFaultPictureCodes', faultCodes);
        },
        togglePrintAllCheckbox(event) {
            const isChecked = event.checked;

            this.printTitlePage = isChecked;
            this.$refs.titlePageChk.ej2Instances.checked = isChecked;
            this.$refs.titlePageChk.ej2Instances.dataBind(); 

            this.printFaultsPage = isChecked
            this.$refs.faultsPageChk.ej2Instances.checked = isChecked;
            this.$refs.faultsPageChk.ej2Instances.dataBind(); 

            this.printPlotPage = isChecked;
            this.$refs.plotPageChk.ej2Instances.checked = isChecked;
            this.$refs.plotPageChk.ej2Instances.dataBind(); 

            if (this.showDefectTab) {
                this.printDefectPage = isChecked;
                this.$refs.defectPageChk.ej2Instances.checked = isChecked;
                this.$refs.defectPageChk.ej2Instances.dataBind(); 
            }

            if (this.showManholeTab) {
                this.printManholePage = isChecked; 
                this.$refs.manholePageChk.ej2Instances.checked = isChecked;
                this.$refs.manholePageChk.ej2Instances.dataBind(); 
            }
       
        },
        printCheckBoxChanged(event) {
            if (event.checked == false) {
                if (this.printAll == true) {
                    this.printAll = false;
                    this.$refs.printAllChk.ej2Instances.checked = false;
                    this.$refs.printAllChk.ej2Instances.dataBind(); 
                }
            }
        }
    },
    created() {
        this.$store.dispatch('getTemplates');
        this.$store.dispatch('SessionsModule/getSessionByID', this.$route.query.id).then(() => {
            this.getObservationDetails();
        });
        this.$store.dispatch('ReportsModule/getReportSettings')
            .then(() => {
                this.originalReportSettings = DMUtils.copy(this.$store.state.ReportsModule.ReportSettings);
            })
 
    },
    mounted() {
        window.addEventListener('afterprint', this.handleAfterPrint);
    },
    beforeUnmount() {
        window.removeEventListener('afterprint', this.handleAfterPrint);
    }
};
</script>
